import { render } from "./WorkAreaForm.vue?vue&type=template&id=f9158f5c"
import script from "./WorkAreaForm.vue?vue&type=script&lang=ts"
export * from "./WorkAreaForm.vue?vue&type=script&lang=ts"
script.render = render

export default script